export const NAMESPACE = 'IDS_CONVERTER/USERS/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
